'use strict';

exports.__esModule = true;

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VerticalSpacing = _styledComponents2.default.div.withConfig({
  displayName: 'Spacing__VerticalSpacing',
  componentId: 'rzvmjy-0'
})(['height:', ';'], function (props) {
  return props.size === 'lg' ? '16px' : '8px';
});

exports.default = VerticalSpacing;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-dev/thread/lib/components/Spacing/index.js
// module id = 1091
// module chunks = 29